import { render } from "./firmaCard.vue?vue&type=template&id=20aad43a"
import script from "./firmaCard.vue?vue&type=script&lang=js"
export * from "./firmaCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__